import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { MediaQueryService } from '@fcom/common/services';

import { QuickLink } from './interfaces';

@Component({
  selector: 'fcom-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrl: './quick-links.component.scss',
  standalone: false,
})
export class QuickLinksComponent implements OnInit {
  private mediaQueryService = inject(MediaQueryService);

  isMobile$: Observable<boolean>;

  @Input()
  links$: Observable<QuickLink[]>;

  @Input()
  showBorder = true;

  @Input()
  showCompact = false;

  @Output() clickLink = new EventEmitter<QuickLink>();

  ngOnInit(): void {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
  }
}
